import Vue from 'vue'
import Vuex from 'vuex'
import moment from 'moment'

Vue.use(Vuex)

let req_url, img_req_url, req_url2, index_path, index2_path, req_url3, vbef_path, domain_path, cookie_type, pro_path
if (process.env.NODE_ENV == 'development') {
  // 本地环境
  req_url = '/php'
  req_url2 = '/java'
  req_url3 = '/app-api'
  img_req_url = 'http://image-cdn-test.vcbeat.top'
  // img_req_url = '/img'
  index_path = 'http://localhost:8081'
  index2_path = 'https://t-www.vbdata.cn'
  vbef_path = 'http://t-vbef.vbdata.cn'
  pro_path = 'https://t-fe-pro.vbdata.cn'
  domain_path = 'localhost'
  cookie_type = 1
} else {
  if (process.env.VUE_APP_FLAG === 'pro') {
    // 生产环境
    req_url = window.location.protocol + '//api.vcbeat.top'
    req_url2 = window.location.protocol + '//vcbeat-vbdata-api.vbdata.cn'
    req_url3 = window.location.protocol + '//app.vbdata.cn'
    index_path = window.location.protocol + '//vbdata.cn'
    index2_path = window.location.protocol + '//www.vbdata.cn'
    img_req_url = window.location.protocol + '//cdn.vcbeat.top'
    vbef_path = window.location.protocol + '//vbef.vbdata.cn'
    pro_path = 'https://pro.vbdata.cn'
    domain_path = 'vbdata.cn'
    cookie_type = 3
  } else {
    // 测试环境
    req_url = window.location.protocol + '//t-api.vcbeat.top'
    req_url2 = window.location.protocol + '//t-vcbeat-vbdata-api.vbdata.cn'
    req_url3 = window.location.protocol + '//t-app-api.vbdata.cn'
    index_path = window.location.protocol + '//t-fe.vbdata.cn'
    index2_path = window.location.protocol + '//t-www.vbdata.cn'
    img_req_url = window.location.protocol + '//image-cdn-test.vcbeat.top'
    vbef_path = window.location.protocol + '//t-vbef.vbdata.cn'
    pro_path = 'https://t-fe-pro.vbdata.cn'
    domain_path = 'vbdata.cn'
    cookie_type = 2
  }
}

function IsPC() {
    var userAgentInfo = navigator.userAgent;
    var Agents = ["Android", "iPhone", "Phone",
        "SymbianOS", "Windows Phone", "OpenHarmony",
        "iPad", "iPod"]
    var flag = true
    for (var v = 0; v < Agents.length; v++) {
        if (userAgentInfo.indexOf(Agents[v]) > 0) {
            flag = false;
            break
        }
    }
    return flag
}

function dealDataRedBool() {
  if(localStorage.data_red_bool) {
    let temp_obj = JSON.parse(localStorage.data_red_bool)
    if(temp_obj.date == moment().format('YYYY-MM-DD')){
      return temp_obj
    } else {
      return { date: moment().format('YYYY-MM-DD')}
    }
  } else {
    return { date: moment().format('YYYY-MM-DD')}
  }
}

const oneYearFromNow = new Date();
oneYearFromNow.setFullYear(oneYearFromNow.getFullYear() + 1);

export default new Vuex.Store({
  state: {
    index_path, 
    index2_path,
    vbef_path,
    req_url,
    req_url2,
    req_url3, 
    pro_path,
    domain_path, 
    cookie_type,
    img_req_url,
    static_img_url: process.env.NODE_ENV == 'development' ? 'http://localhost:8081/' : (process.env.VUE_APP_FLAG === 'pro'? window.location.protocol +'//static-cdn.vcbeat.top/vbdata-fe/' : window.location.protocol +'//t-fe.vbdata.cn/'),
    static_pdf_url: process.env.NODE_ENV == 'development' ? 'http://localhost:8081/' : (process.env.VUE_APP_FLAG === 'pro'? window.location.protocol +'//cdn.vcbeat.top/' : window.location.protocol +'//image-cdn-test.vcbeat.top/'),
    share_img_url: 'http://cdn.vcbeat.top',
    user_key: '',
    before_user_key: '',
    user: {},
    collect_message: localStorage.collect_message || 0,
    atten_message: localStorage.atten_message || 0,
    collect_c_message: localStorage.collect_c_message || 1,

    news_topic_type: '',

    attention: '',
    attention_change: '',

    highest_edu: [{id:'0',name:'大专及以下'},{id:'1',name:'本科'},{id:'2',name:'硕士'},{id:'3',name:'博士'}],

    dict_is: false, // 临时字段，用来判断是否请求字典
    list_tiaojian: '',
    topic_read_uids: [],

    pushTopic_uids: [],

    // 手机端用
    is_pc: IsPC(),
    topic_newest_id: '',

    order_uid_arr: [], // 订单数组（开发票用）
    theme_switch: true,

    current_app_identity_show: 1,
    // 医院评级
    hos_level: [
      { id: '31', name: '三级甲等' },
      { id: '32', name: '三级乙等' },
      { id: '33', name: '三级丙等' },
      { id: '21', name: '二级甲等' },
      { id: '22', name: '二级乙等' },
      { id: '23', name: '二级丙等' },
      { id: '11', name: '一级甲等' },
      { id: '12', name: '一级乙等' },
      { id: '13', name: '一级丙等' },
      { id: '0', name: '未评级' },
    ],
    hos_cz_type: [
      { id: '1', name: '公立' },
      { id: '2', name: '民营' },
      { id: '3', name: '合资' },
      { id: '4', name: '外资' },
      { id: '5', name: '部队医院' }
    ],
    h_emr_level: [
      { id: '', name: '未评级' },
      { id: '0', name: '0级' },
      { id: '1', name: '1级' },
      { id: '2', name: '2级' },
      { id: '3', name: '3级' },
      { id: '4', name: '4级' },
      { id: '5', name: '5级' },
      { id: '6', name: '6级' },
      { id: '7', name: '7级' }
    ],
    hlht_level1: [
      { id: '1', name: '一级' },
      { id: '2', name: '二级' },
      { id: '3', name: '三级' },
      { id: '4', name: '四级' }
    ],
    hlht_level2: [
      { id: '1', name: '甲等' },
      { id: '2', name: '乙等' },
      { id: '3', name: '丙等' }
    ],
    star_level: [
      { id: '1', name: '1星级' },
      { id: '2', name: '2星级' },
      { id: '3', name: '3星级' },
      { id: '4', name: '4星级' },
      { id: '5', name: '5星级' }
    ],
    topic_entity_count: '',
    topic_tag_count: '',
    html_title: '', // 单页应用动态修改title（手机端用字段）
    // order_url: '/specialList' // 记录购买需要返回的链接
    financing_index: '',

    mergers_params: '',
    even_params: '',
    comp_params: '',
    org_params: '',
    hospital_params: '',
    policy_params: '',
    report_params: '',
    activity_params: '',
    notice_params: '',
    product_params: '',
    prospectus_params: '',
    datahotsearchkey: '',
    from_name: '',
    login_cb: '',
    version: 3922,  //资源版本号
    version_cb: false,
    data_red_bool: dealDataRedBool(),
    apply_now: false, // 是否点击过立即申请
    apply_btn: true,
    uUid: null,
		uUserId: null,
    loginIndex: false,
    enter_type: 35,
    oneYearFromNow
  },
  mutations: {
    setUUid(state, values) {
  		state.uUid = values
  	},
    setUUserId(state, values) {
  		state.uUserId = values
  	},
    topicEntityCount(state, values) {
  		state.topic_entity_count = values
  	},
    topicTagCount(state, values) {
  		state.topic_tag_count = values
  	},
    updateUser(state, values) {
  		state.user = values
  	},
  	updateUserKey(state, values) {
  		state.user_key = values
  	},
    beforeUserKey(state, values) {
      state.before_user_key = values
    },
    updateFilter(state, values) {
      state.attention_change = Math.random()
  		state.attention = values
  	},
    updateTiaojian(state, values) {
      state.list_tiaojian = values
    },
    updateReadList(state, values) {
      state.topic_read_uids = values
    },
    updatePushTopic(state, values) {
      state.pushTopic_uids = values
    },
    updateTopicNewestId(state, values) {
      state.topic_newest_id = values
    },
    updateOrderArr(state, values) {
      state.order_uid_arr = values
    },
    updateDict(state, values) {
      for (let item in values) {
        if (item=='currency') {
          state['unit'] = values[item]
        } else {
          state[item] = values[item]
        }
      }
    },
    updateDis(state, values) { // 判断是否请求字典
      state.dict_is = values
    },
    updateThemeSwitch(state, values) { // 判断是否请求字典
      state.theme_switch = values
    },
    updateIdentity(state, values) { // 修改用户身份修改模态框
      state.current_app_identity_show = values
    },
    updateCollectMessage(state, values) { // 更新是否提示收藏消息
      state.collect_message = values
    },
    updateAttenMessage(state, values) { // 更新是否提示收藏消息
      state.atten_message = values
    },
    updateCCollectMessage(state, values) { // 更新是否提示取消收藏消息
      state.collect_c_message = values
    },
    updateHtmlTitle(state, values) { // 更新单页应用标题
      state.html_title = values
    },
    // updateOrderUrl(state, values) { // 更新购买返回地址
    //   state.order_url = values
    // }
    updateFinancingIndex(state, values) { // 研图
      state.financing_index = values
    },
    updateMergersParams(state, values) { // 并购列表筛选条件
      state.mergers_params = values
    },
    updateEvenParams(state, values) { // 融资列表筛选条件
      state.even_params = values
    },
    updateCompParams(state, values) { // 公司列表筛选条件
      state.comp_params = values
    },
    updateOrgParams(state, values) { // 机构列表筛选条件
      state.org_params = values
    },
    updateHospitalParams(state, values) { // 医院列表筛选条件
      state.hospital_params = values
    },
    updatePolicyParams(state, values) { // 政策列表筛选条件
      state.policy_params = values
    },
    updateReportParams(state, values) { // 报告列表筛选条件
      state.report_params = values
    },
    updateActivityParams(state, values) { // 活动列表筛选条件
      state.activity_params = values
    },
    updateNoticeParams(state, values) { // 公告列表筛选条件
      state.notice_params = values
    },
    updateDatahotsearchkey(state, values) {
      state.datahotsearchkey = values
    },
    updateProductParams(state, values) {
      state.product_params = values
    },
    updateProspectusParams(state, values) {
      state.prospectus_params = values
    },
    updateFromName(state, values) {
      state.from_name = values
    },
    updateLoginCb(state, values) {
      state.login_cb = values
    },
    updateVersionCb(state, values) {
      state.version_cb = values
    },
    updateDataRedBool(state, values) {
      state.data_red_bool = values
    },
    updateApplyNow(state, values) {
      state.apply_now = values
    },
    updateApplyBtn(state, values) {
      state.apply_btn = values
    },
    updateLoginIndex(state, values) {
      state.loginIndex = values
    },
    setEnterType(state, values) {
      state.enter_type = values
    },
  }
})
